import React from "react";

const GuarantorsDisplay = ({ guarantors, guarantor }) => {
    if (guarantor !== "Yes") return null;
    if (!guarantors || guarantors.length === 0) return null;
    const names = guarantors.map((g) => (g && g.name ? g.name : "")).filter((n) => n).join(", ");
    if (!names) return null;
    return (
        <div>
            <strong>Other Guarantors:</strong> {names}
        </div>
    );
};

export default GuarantorsDisplay;
